import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'
import Script from 'react-load-script'
import moment from 'moment'

class Razorscript extends React.Component {

  render(){
    return <Script
      url="https://checkout.razorpay.com/v1/checkout.js"
      onLoad={this.props.handleScriptLoad}
    />
  }
}



export default class Billing extends React.Component {

  constructor() {
    super()
    document.title="Billing"
    this.capturePayment = this.capturePayment.bind(this)
    this.getBillings = this.getBillings.bind(this)
    this.handleScriptLoad = this.handleScriptLoad.bind(this)
    this.openPG = this.openPG.bind(this)
    this.state = {
      payment_id: null,
      loaded: false,
      bills : [],
      payment_required: false,
      options : {
          "key": "rzp_test_QtggytX6Ruj9sr",
          "amount": "400000",
          "name": "Goodsbill",
          "description": "Purchase Subscription",
          "handler":  (response) => {
            this.capturePayment(response)
          },
          "theme": {
              "color": "#4582ec"
          }
      }
    }
    this.getBillings()
  }

  openPG() {
    let rPay
    if(this.state.loaded) {
      rPay = new window.Razorpay(this.state.options)
      rPay.open()
    }
  }
  handleScriptLoad() {
    this.setState({loaded:true})
    console.log("loaded");
  }

  getBillings() {
    axios({
      url: '/get_billing_info/',
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
      if(response.status === 200) {
          this.setState({bills:response.data.bills, payment_required: response.data.payment_required})
      }
    }).catch((err)=> {
      console.log(err);
    })
  }

  capturePayment(response) {
    this.setState({waiting_for_verification:true, wait_msg: "Please wait while we verify your transaction..."})

    if(typeof response !== "undefined" && typeof response.razorpay_payment_id !== "undefined") {

      axios({
        url: '/capture_payment/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: {payment_id:response.razorpay_payment_id}
      }).then((response)=> {

        if(response.status === 200) {
          this.setState({waiting_for_verification:true, wait_msg: <div className="alert alert-success"><p><b>Awesome..!</b>  Payment completed successfully.</p></div>})
          setTimeout(()=>{
            window.location.reload(true)
          }, 2000)
        }
      }).catch((err)=> {
        console.log(err);
      })

    }

  }

  render() {


    let bills = this.state.bills

    let please_pay

    if(this.state.payment_required) {
      please_pay = <div className="panel panel-default">
      <div className="panel-body">
                      <h4 >
                        Hi, your annual fee is <strong>&#8377; 4000.00</strong>
                      </h4>
                        <div className="psmall">
                          <a href="https://imjo.in/PNcuFw" target="_blank" className="btn btn-success">Pay Now</a>
                        </div>

              </div>
      </div>
    }

    let bilist

    let header = <thead>
        <tr>
          <th>Bill ID</th>
          <th>Paid On</th>
          <th>Valid Till</th>
          <th>Amount</th>
          <th>Payment Method</th>
          <th className="text-right">Status</th>
        </tr>
    </thead>

    if(bills.length > 0 ) {
      bilist = bills.map((bill, index)=> {

        return <tr>
            <td>
              {bill.uuid}
            </td>
            <td>
            {moment(bill.payment_date).format('DD-MM-YYYY')}
            </td>
            <td>
            {moment(bill.valid_till).format('DD-MM-YYYY')}
            </td>
            <td>
              ₹{bill.amount}
            </td>
            <td>
              {bill.method}
            </td>
            <td className="text-right">
              <strong><i className="text-success">{bill.status}</i></strong>
            </td>
        </tr>
      })
    }

    let wait_msg
    if( typeof this.state.waiting_for_verification !== "undefined" && this.state.waiting_for_verification) {
      wait_msg = this.state.wait_msg
      please_pay = ""
      bilist = ""
    }



    return <div className="container">
              <Razorscript handleScriptLoad={this.handleScriptLoad} />
          <section className="medium">
            <h3 className="h3">Billing </h3>
          </section>
            {wait_msg}
          {please_pay}
          <div className="table-responsive">
            <div className="panel panel-default">

                <table className="table">
                  {header}
                  <tbody>
                    {bilist}
                  </tbody>

                </table>

            </div>
          </div>
    </div>

  }
}



// WEBPACK FOOTER //
// ./src/components/profile/billing.js